"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.splice.js");
var _elementUi = require("element-ui");
var _custom_map_config = require("./custom_map_config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: "BMap",
  props: {
    searchShow: {
      type: Boolean,
      default: false
    },
    mapConfig: {
      type: Object,
      default: function _default() {
        return {
          mapId: "mapContainer",
          zoom: 15,
          center: [120.93251, 30.837122],
          enableScrollWheelZoom: true
        };
      }
    },
    styleOptions: {
      type: Object,
      default: function _default() {
        return {
          strokeColor: "red",
          //边线颜色。
          fillColor: "red",
          //填充颜色。当参数为空时，圆形将没有填充效果。
          strokeWeight: 3,
          //边线的宽度，以像素为单位。
          strokeOpacity: 0.8,
          //边线透明度，取值范围0 - 1。
          fillOpacity: 0.6,
          //填充的透明度，取值范围0 - 1。
          strokeStyle: "solid" //边线的样式，solid或dashed
        };
      }
    },

    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: Number,
      default: 460
    }
  },
  data: function data() {
    return {
      options: [],
      loading: false,
      value: "",
      map: null,
      drawingManager: null,
      overlays: [],
      center: [120.93251, 30.837122],
      type: null,
      markerLnglat: [],
      local: null
    };
  },
  mounted: function mounted() {
    this.init();
    this.drawingManager = new BMapLib.DrawingManager(this.map, {
      isOpen: false,
      //是否开启绘制模式
      enableDrawingTool: false,
      //是否显示工具栏
      drawingToolOptions: {
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        //位置
        offset: new BMap.Size(5, 5) //偏离值
      },

      circleOptions: this.styleOptions,
      //圆的样式
      polylineOptions: this.styleOptions,
      //线的样式
      polygonOptions: this.styleOptions,
      //多边形的样式
      rectangleOptions: this.styleOptions //矩形的样式
    });
    //添加鼠标绘制工具监听事件，用于获取绘制结果
    this.drawingManager.addEventListener("overlaycomplete", this.overlayComplete);
  },
  methods: {
    change: function change(value) {
      var point = {};
      if (value) {
        point = this.options.filter(function (item) {
          return item.uid == value;
        })[0].point;
        this.clearAll();
        this.showOverlays("marker", [point.lng, point.lat]);
        this.$emit("showLnglat", {
          type: this.type,
          data: {
            point: point
          }
        });
        this.value = "";
        this.options = [];
      }
    },
    initLocal: function initLocal() {
      var that = this;
      var options = {
        onSearchComplete: that.searchCallback,
        pageCapacity: 100
      };
      this.local = new BMap.LocalSearch(this.map, options);
      // local.search("公园");
    },
    remoteMethod: function remoteMethod(query) {
      if (query) {
        this.local.search(query);
      } else {
        this.options = [];
      }
    },
    searchCallback: function searchCallback(results) {
      var that = this;
      // 判断状态是否正确
      if (that.local.getStatus() == 0) {
        console.log(results);
        if (results) {
          // 假定列表key是_r，如Br，Ir，Vr，当前版本为“Vr”
          // 找到这个key
          var keys = Object.keys(results);
          var patt = /^[A-Z]r$/;
          var pattKey = keys.find(function (item) {
            return patt.test(item);
          }) || 'Vr';
          that.options = results[pattKey].map(function (item) {
            item.address = "\u3010".concat(item.title, "\u3011") + item.address;
            return item;
          });
        }
      }
    },
    init: function init() {
      this.map = new BMap.Map(this.mapConfig.mapId);
      this.map.setMapStyle({
        styleJson: _custom_map_config.mapCustomJson
      });
      this.map.centerAndZoom(this.pointConversion(this.center[0], this.center[1]), this.mapConfig.zoom);
      this.initLocal(); // 初始化本地搜索功能
      this.map.enableScrollWheelZoom(this.mapConfig.enableScrollWheelZoom);
    },
    // 地图中心点设置  120.93251, 30.837122
    setMapCenter: function setMapCenter() {
      var lng = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120.93251;
      var lat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30.837122;
      this.map.panTo(this.pointConversion(lng, lat));
      this.map.setZoom(this.mapConfig.zoom);
    },
    /**
     * 绘制多边形方法
     * @param type BMAP_DRAWING_POLYGON:多边形  BMAP_DRAWING_RECTANGLE:多边形矩形
     * BMAP_DRAWING_POLYLINE:多边形画线
     */
    draw: function draw(type) {
      // 设置当前的绘制模式，参数DrawingType，为5个可选常量:
      // BMAP_DRAWING_MARKER 画点
      // BMAP_DRAWING_CIRCLE 画圆
      // BMAP_DRAWING_POLYLINE 画线
      // BMAP_DRAWING_POLYGON 画多边形
      // BMAP_DRAWING_RECTANGLE 画矩形
      this.type = type;
      switch (type) {
        case "marker":
          type = BMAP_DRAWING_MARKER;
          break;
        case "polygon":
          var polygonFlag = this.overlays.some(function (item) {
            return item.drawingMode == type;
          });
          if (polygonFlag) {
            (0, _elementUi.Message)({
              message: "已存在区域",
              type: "warning",
              offset: 100
            });
            return;
          }
          (0, _elementUi.Message)({
            message: "双击保存区域",
            type: "warning",
            offset: 130
          });
          type = BMAP_DRAWING_POLYGON;
          break;
        case "circle":
          type = BMAP_DRAWING_CIRCLE;
          break;
        case "polyline":
          type = BMAP_DRAWING_POLYLINE;
          break;
        default:
          break;
      }
      this.drawingManager.open();
      this.drawingManager.setDrawingMode(type);
    },
    // 显示覆盖物
    showOverlays: function showOverlays(type, data) {
      var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var option;
      var point = new BMap.Point(data[0], data[1]);
      console.log(data);
      switch (type) {
        case "polygon":
          var PolygonArr = [];
          data.forEach(function (item) {
            var lngLat = item.split(",");
            PolygonArr.push(new BMap.Point(lngLat[0], lngLat[1]));
          });
          option = new BMap.Polygon(PolygonArr, this.styleOptions);
          break;
        case "marker":
          option = new BMap.Marker(point);
          this.setMapCenter(data[0], data[1]);
          break;
        case "circle":
          this.clear("circle");
          option = new BMap.Circle(point, radius);
          // this.setMapCenter(data[0], data[1]);
          break;
        default:
          break;
      }
      option.drawingMode = type;
      this.overlays.push(option);
      this.map.addOverlay(option);
    },
    // 清除覆盖物
    clear: function clear(type) {
      this.type = type;
      for (var i = 0; i <= this.overlays.length; i++) {
        if (this.overlays[i] && type == this.overlays[i].drawingMode) {
          this.map.removeOverlay(this.overlays[i]);
          this.overlays.splice(i, 1);
        }
      }
    },
    clearAll: function clearAll() {
      for (var i = 0; i <= this.overlays.length; i++) {
        this.map.removeOverlay(this.overlays[i]);
      }
      this.overlays = [];
      this.$emit("showLnglat", {
        type: this.type,
        data: null
      });
    },
    // 绘制完成
    overlayComplete: function overlayComplete(e) {
      if (this.type == "marker") {
        this.clear("marker");
        this.setMapCenter(e.overlay.point.lng, e.overlay.point.lat);
        this.$emit("showLnglat", {
          type: this.type,
          data: e.overlay
        });
      } else if (this.type == "polygon") {
        this.$emit("showPolygonLnglat", {
          type: this.type,
          data: e.overlay
        });
      }
      e.overlay.drawingMode = this.type;
      this.overlays.push(e.overlay);
      this.drawingManager.close();
    },
    // 获取图层
    getAllOverlays: function getAllOverlays() {
      console.log(this.overlays);
    },
    pointConversion: function pointConversion() {
      if ((0, _typeof2.default)(arguments[0]) === "object") {
        return new BMap.Point(arguments[0][0], arguments[0][1]);
      } else if (arguments[0] && arguments[1]) {
        return new BMap.Point(arguments[0], arguments[1]);
      } else {
        (0, _elementUi.Message)({
          message: "地图中心定位失败",
          type: "warning"
        });
        return new BMap.Point(this.mapConfig.center[0], this.mapConfig.center[1]);
      }
    }
  }
};
exports.default = _default2;